<template>
    <div class="bg">
        <headline :params="headLines"></headline>
        <div class="content-container" :style="'padding:'+contentPadding">
            <div v-show="showCompose" class="mask-container">
                <div v-show="audioLoading" class="mask">
                    <p>音频正在合成</p>
                    <img src="./assets/load.svg">
                </div>
                <div v-show="isAudioSubmit" class="voiceEditResult-container">
                    <div class="title">合成音频提交</div>
                    <div class="content">
                        <div class="left-container">
                            <div class="disk-container">
                                <img class="disk" src="./assets/disk.png">
                                <img @click="audioPlayer.play();isPlayAudio=true" v-show="isPlayAudio==false" class="play" src="./assets/play.png">
                                <img @click="audioPlayer.pause();isPlayAudio=false" v-show="isPlayAudio" class="pause" src="./assets/pause.png">
                            </div>

                            <div ref="line" class="slide-container">
                                <div class="time-container">
                                    <span>{{startTime}} / {{endTime}}</span>
                                </div>
                                <div @click="isMouseClick=true;clickJump($event)" class="line-container">
                                    <div ref="sliderLeft" class="line" :style="'width:' + audioPercent">
                                        <p @mouseenter="isMouseClick=false" @mouseout="timeNavi();isMouseClick=false;" @mousedown="isMouseClick=true;timeStop();isPlayAudio=false" @mouseup="timeNavi();isMouseClick=false;" @mousemove="slideMouseMove" class="slider"></p>
                                    </div>
                                </div>
                            </div>

                            <audio ref="audioPlayer"></audio>
                        </div>
                        <div class="right-container">
                            <div class="title">
                                <span>*</span>
                                <p>标题</p>
                            </div>
                            <div class="input">
                                <input v-model="rename" type="text">
                            </div>
                            <div class="notice">
                                <img src="./assets/previewAlertIcon.png">
                                <span>提交后，音频将在多媒体的音频列表中出现</span>
                            </div>
                        </div>
                    </div>
                    <div class="footer">
                        <div @click="renameAudio" class="button green">确认提交</div>
                        <div @click="showCompose=false;audioLoading=true;isAudioSubmit=false;delAudio()" class="button">取消</div>
                    </div>
                </div>
                <div v-show="isComposeSuccess" class="success-container">
                    <img src="./assets/success.png">
                    <p>音频提交成功</p>
                    <span>{{successInfo}}</span>
                    <div class="button">
                        <div @click="showCompose=false;audioLoading=true;isComposeSuccess=false;windowClose()">确认</div>
                    </div>
                </div>
                <div v-show="isComposeFail" class="fail-container">
                    <img src="./assets/ques.png">
                    <p>合成失败</p>
                    <span>合成失败</span>
                    <div class="button">
                        <div @click="showCompose=false;audioLoading=true;isComposeFail=false">确认</div>
                    </div>
                </div>
                <div v-show="false" class="leave-container">
                    <img src="./assets/ques.png">
                    <p>确认离开编辑界面</p>
                    <span>音频还未合成，关闭后，编辑记录讲不好被保存</span>
                    <div class="button">
                        <div>确认</div>
                        <div class="grey">取消</div>
                    </div>
                </div>
            </div>
            <input id="hideInput" type="text">
            <div class="container">
                <div id="voiceEditArticle">
                    <div :hidden="hideContent" id="article-container" :style="'height:'+inputHeight"></div>
                </div>
            </div>
            <voiceEditBtn
                v-if="isLoad"
                ref="voiceEditBtn"
                :editConfig='editConfig'
                @delArticle="delArticle"
                @resumeArticle="resumeArticle"
                @compose="compose" 
                @setContent="setContent"
                @setLoading="setLoading"
                @getClipDate="getClipDate" 
                @nowTime="nowTime">
            </voiceEditBtn>
        </div>
    </div>
</template>

<script>
import mainCommon from '../../common/common'
import common from './common/common'
import * as config from './common/config'
import {apis} from '@common/config'
import voiceEditBtn from './btn/voiceEditRadioBtn'
import headline from '@components/headline';
import qs from 'qs';

export default {
    components: {
        headline,
        voiceEditBtn
    },
    data() {
        return {
            successInfo: '请在多媒体库的音频列表中查看新合成的音频',
            headLines: {
                title: '智能音频编辑',
                showLink: false,
                filter: false
            },
            editConfig: {},
            uid: '',
            isPlay: true,
            content: '',
            contentSave: '',
            editor: null,
            changeIndex: 0,
            title: '',
            textArr: [],
            inputWidth: '590px',
            loading: false,
            wordList: '',
            oldIndex:9999999,
            inputHeight: '570px',
            clipDate: [],
            copyArrSave: [],
            hideContent: true,
            contentPadding: '30px 50px',
            leftPadding: '50px',
            composeUrl: '',
            canCompose: true,
            outPutTitle: '',
            copyOnSaveArr: [],
            VoiceEdit: null,
            setDelInfo: '', // 设置音频删除
            submitContent: {}, // 设置音频文本
            resumeDel: '', // 设置音频恢复
            src: '', // 音频剪辑播放链接、波形json链接、文本内容
            setClipDate: '', // 设置删除段内容
            maxSecProp: '', // 最大时间
            dblPlay: '', // 双击事件
            playPauseAudio: '', // 开始暂停音频播放
            voiceOption: {
                src: '', // 音频剪辑播放链接、波形json链接、文本内容
                setDelInfo: '',
                submitContent: '',
                resumeDel: '',
                setClipDate: '',
                maxSecProp: '',
                dblPlay: '',
                playPauseAudio: ''
            },
            showCompose: false,
            isMouseClick: false,
            audioPercent: '0%',
            isLoad: false,
            isPlayAudio: false,
            audioLoading: true,
            isAudioSubmit: false,
            isComposeSuccess: false,
            isComposeFail: false,
            rename: null,
            composeContent: null,
            audioPlayer: null,
            startTime: '00:00:00',
            endTime: '00:00:00',
            duration: null,
            percent: 0,
            interval: null,
            newTime: null
        }
    },
    watch: {
        title(to) {
            var titleArr = to.split('.');
            var len = to.split('.').length-1;
            var arr = [];
            for(var i=0; i<len; i++){
                arr.push(titleArr[i])
            }
            var outPutTitle = arr.join('.');
            this.outPutTitle = outPutTitle + '.wav';
        },
        isAudioSubmit(to) {
            if(!to){
                this.audioPlayer.pause()
                this.isPlayAudio = false;
            }
        },
        // isPlayAudio(to) {
        //     // console.log(to)
        //     let that = this;
        //     if(to){
        //         this.newTime = setInterval(() => {
        //             that.startTime = that.s2hms(parseInt(that.audioPlayer.currentTime));
        //             let percent = ((parseInt(that.audioPlayer.currentTime)/parseInt(that.audioPlayer.duration))*100).toFixed(2) + '%';
        //             that.audioPercent = percent;
        //             // console.log(123123)
        //         }, 500);
        //     }else{
        //         clearInterval(this.newTime)
        //     }
        // }
    },
    beforeDestroy() {
        // clearInterval(this.newTime)
    },
    methods: {
        windowClose() {
            window.close()
        },
        clickJump(e) {
            let clientX = this.$refs.line.getBoundingClientRect().x;
            let width = 310;
            let left = 0;
            let percent = 0;

            if(e.clientX - clientX <= 0){
                left = '0%';
            }else if(e.clientX - clientX >= 310){
                left = '100%';
            }else{
                percent = (((e.clientX - clientX) / width) * 100).toFixed(2)
                left = (((e.clientX - clientX) / width) * 100).toFixed(2) + '%'
            }

            this.percent = percent;
            this.audioPercent = left;

            this.$refs.sliderLeft.style.width = left;

            this.timeNavi()

            this.isMouseClick = false;
        },
        timeStop() {
            var that = this;
            // clearInterval(that.interval);
            // that.interval = null;
            that.audioPlayer.pause();
        },
        timeNavi() {
            if(this.isMouseClick){
                let that = this;
                let percent = this.percent/100;
                let time = (percent * this.duration).toFixed(2);
                this.audioPlayer.currentTime = time;
                this.audioPlayer.play()
                this.isPlayAudio = true;
                this.isMouseClick = false;
            }
        },
        renameAudio() {
            if(this.rename == '' || this.rename == null || this.rename == undefined){
                this.$toast('标题不能为空')
            }else{
                var info ={}
                info['idstring'] = this.composeContent.idstring;
                info['title'] = this.rename;
                info['ai_clear'] = this.$route.params.idString;
                mainCommon.myFetch(apis.File_rename,info)
                .then((res) => {
                    if(res){
                        this.isAudioSubmit = false;
                        this.isComposeSuccess = true;
                    }else{
                        this.isAudioSubmit = false;
                        this.isComposeFail = true;
                    }
                })
            }
        },
        delAudio() {
            var info ={}
            info['idstring'] = this.composeContent.idstring;
            info['subject_id'] = this.$route.params.id;
            info['subject_type'] = this.$route.params.type;
            mainCommon.myFetch(apis.File_delete,info)
            .then((res) => {
                
            })
        },
        s2hms(time) {
            var min=Math.floor(time%3600);
            var hh = Math.floor(time/3600) < 10 ? '0' + Math.floor(time/3600) : Math.floor(time/3600)
            var mm = Math.floor(min/60) < 10 ? '0' + Math.floor(min/60) : Math.floor(min/60);
            var ss = time%60 < 10 ? '0' + time%60 : time%60;
            return hh + ":" + mm + ":"+ ss
            // console.log(hh + ":" + mm + ":"+ ss)
        },
        slideMouseMove(e) {
            if(this.isMouseClick){
                let clientX = this.$refs.line.getBoundingClientRect().x;
                let width = 310;
                let left = 0;
                let percent = 0;

                if(e.clientX - clientX <= 0){
                    left = '0%';
                }else if(e.clientX - clientX >= 310){
                    left = '100%';
                }else{
                    percent = (((e.clientX - clientX) / width) * 100).toFixed(2)
                    left = (((e.clientX - clientX) / width) * 100).toFixed(2) + '%'
                }

                this.percent = percent;
                this.audioPercent = left;

                this.$refs.sliderLeft.style.width = left;
            }
        },
        setContent(res) {
            this.wordList = res.wordList;
        },
        setLoading(res) {
            this.loading = res.loading;
        },
        getClipDate(res) {
            this.clipDate = res.clipDate;
        },
        nowTime(val) {
            var that = this;
            this.wordList.forEach(function(el,index){
                var bg = Number(el.bg)/1000;
                var ed = Number(el.ed)/1000;
                if(val.time>=bg && val.time<=ed){
                    if(index!=that.oldIndex){
                        $('#'+that.editConfig.el+' > span').removeClass('on');
                        $('#'+that.editConfig.el+' > span:eq('+index+')').addClass('on');
                        that.oldIndex = index;
                    }
                }
            })
        },
        getDetail() {
            var that = this;
            var info = {};
            info['idstring'] = this.$route.params.idString;
            mainCommon.myFetch(apis.editaudioinfo,info)
            .then((res) => {
                if(res.detail){
                    that.editConfig = {
                        el: 'article-container',
                        composeUrl: '', // 音频地址
                        wordContent: res.detail.public_result_explode && JSON.stringify(res.detail.public_result_explode), // 公有云文本内容
                        filePath: res.detail.url, // 音频文件路径
                        wave_json: res.detail.wave_json, // 波形文件路径
                        title: res.detail.title, // 标题
                        edit_result: '', // 修改后的文本内容
                        content: res.detail.result && JSON.parse(res.detail.result) // 文本内容
                    }
                }
            })
        },
        // 合成事件compose 回调loading 合成事件的加载过程 回调result合成成功的数据返回
        compose() { // 合成事件
            var that = this;
            var resultArr = [];
            var resultArr1 = [];
            var resultArr2 = [];
            var resultArr3 = {};
            var arr = [];
            var minBg = 0;
            var maxBg = 0;
            var len = $('#article-container > span').length;
            for(var i=0; i<len; i++){
                if($('#article-container > span:eq('+i+')').text()!=''){
                    arr.push($('#article-container > span:eq('+i+')').html())
                }
            }
            var length = arr.length;
            for(var j=0; j<length; j++){
                var subArr = [];
                var subArr1 = [];
                var arr1 = [];
                var len1 = $(arr[j]).length
                var bg = $(arr[j]).attr('data-bg');
                var ed = $(arr[j]).attr('data-ed');
                var oldIndex = $(arr[j]).attr('data-index');
                var val = $(arr[j]).text();
                var span = $(arr[j]).find('span')
                var newHtml = ''
                for(var x=0; x<len1; x++){
                    if($(span.prevObject[x]).hasClass('on')){
                        var sbbg = 0;
                        var sbed = 0;
                        var sbval = '';
                        subArr.push({
                            bg: sbbg,
                            ed: sbed,
                            val: sbval
                        })
                        newHtml += sbval
                    }else{
                        var sbbg = span.prevObject[x].dataset.bg;
                        var sbed = span.prevObject[x].dataset.ed;
                        var index = span.prevObject[x].dataset.index;
                        var index1 = span.prevObject[x].dataset.index1;
                        var sbval = span.prevObject[x].innerText;
                        subArr.push({
                            bg: sbbg,
                            ed: sbed,
                            val: sbval
                        })
                        subArr1.push({
                            wordBg: sbbg,
                            wordEd: sbed,
                            wordsName: sbval
                        })
                        newHtml += sbval
                    }
                }
                if(subArr.length == 0){
                    resultArr.push({
                        bg: 0,
                        ed: 0,
                        val: '',
                        sub: subArr
                    })
                }else{
                    resultArr.push({
                        bg: subArr[0].bg,
                        ed: subArr[subArr.length-1].ed,
                        val: newHtml,
                        sub: subArr
                    })
                }
                if(subArr1.length == 0){
                    console.log(1)
                }else{
                    resultArr1.push({
                        bg: subArr1[0].wordBg,
                        ed: subArr1[subArr1.length-1].wordEd,
                        index: oldIndex,
                        onebest: newHtml,
                        wordsResultList: subArr1
                    })
                    resultArr2.push({
                        bg: subArr1[0].wordBg/10,
                        ed: subArr1[subArr1.length-1].wordEd/10,
                        result: newHtml
                    })
                }
            }

            var oldIndex = 0;
            var index2 = 0;
            var arr8 = [];
            var arr9 = [];
            var started = 0;
            var lastStarted = 0;
            var ended = 0;
            var canOutput = false;
            var len6 = resultArr.length-1;
            var len7 = resultArr[len6].sub.length-1;
            resultArr.forEach(function(el,key){
                el.sub.forEach(function(e,index){
                    if(e.bg==0&&e.ed==0){
                        lastStarted=0;
                        if(canOutput){
                            arr8.push({
                                bg: started,
                                ed: ended,
                                index: index2
                            })
                            index2++;
                            canOutput = false;
                        }
                    }else{
                        if(lastStarted==0){
                            started=e.bg;
                            lastStarted=e.bg;
                        }
                        ended = e.ed;
                        canOutput = true;
                        if(key==len6&&index==len7&&index2!=oldIndex){
                            arr8.push({
                                bg: started,
                                ed: ended,
                                index: index2
                            })
                            oldIndex = index2;
                        }else if(key==len6&&index==len7&&index2==oldIndex){
                            arr8.push({
                                bg: started,
                                ed: ended,
                                index: index2
                            })
                            oldIndex = index2;
                        }
                    }
                })
            })
            if(arr8.length==0){
                started = resultArr[0].sub[0].bg;
                ended = resultArr[len6].sub[len7].ed
                arr8.push({
                    bg: started,
                    ed: ended,
                    index: 0
                })
                oldIndex = 0;
            }
            that.clipDate.forEach(function(val,index){
                if(val.blank == 1){
                    arr9.push({
                        bg: val.startTime,
                        ed: val.endTime
                    })
                }
            })

            resultArr3.public_result = resultArr1;
            resultArr3.result = resultArr2;
            resultArr3.clipDate = that.clipDate;
            resultArr3.timeLine = arr8;
            resultArr3.blankArea = arr9;
            var segment_list = {}
            segment_list['timeLine'] = arr8;
            segment_list['blankArea'] = arr9;
            this.startCompose(segment_list)
            // var result = JSON.stringify(resultArr3);
            
        },
        startCompose(segment_list) {
            let info = {};
            let date = new Date();
            let year = date.getFullYear();
            let month = date.getMonth()+1;
            if(month<10){
                month = '0' + month;   
            }
            let day = date.getDate();
            if(day<10){
                day = '0' + day;
            }
            let hour = date.getHours();
            if(hour<10){
                hour = '0' + hour
            }
            let min = date.getMinutes();
            if(min<10){
                min = '0' + min
            }
            let sec = date.getSeconds();
            if(sec<10){
                sec = '0' + sec
            }
            let time = year+'-'+month+'-'+day+' '+hour+':'+min+':'+sec;
            this.rename = this.editConfig.title+' '+time;
            console.log(this.$route.params.id,this.$route.params.type)
            if(this.$route.params.id == null || this.$route.params.id == undefined || this.$route.params.type == null || this.$route.params.type == undefined || this.$route.params.id == 'undefined' || this.$route.params.type == 'undefined'){
                info['idstring'] = this.$route.params.idString;
                info['segment_list'] = JSON.stringify(segment_list);
                this.successInfo = '请在我的素材中查看新合成的音频'
            }else{
                info['idstring'] = this.$route.params.idString;
                info['segment_list'] = JSON.stringify(segment_list);
                info['subject_id'] = this.$route.params.id;
                info['subject_type'] = this.$route.params.type;
                this.successInfo = '请在多媒体库的音频列表中查看新合成的音频'
            }
            mainCommon.myFetch(apis.editaudio,info)
            .then((res) => {
                if(res){
                    this.showCompose = true;
                }
            })
        },
        // 保存事件saveArticle 回调loading 保存事件的加载过程 回调result保存成功的数据返回
        saveArticle() {
            var that = this;
            this.$refs.voiceEditBtn.saveArticle({
                clipDate: that.clipDate,
                result(result) {
                    console.log(result)
                    return false;
                }
            });
        },
        // 删除事件delArticle 回调loading 删除事件的加载过程 回调setDelInfo被删除段时间内容数据返回 回调submitContent包含处理好的删除内容的完整数据返回
        delArticle() {
            // var that = this;
            this.$refs.voiceEditBtn.delArticle();
        },
        // 恢复事件resumeArticle 回调loading 恢复事件的加载过程 回调resumeDel被恢复段时间内容数据返回 回调submitContent包含处理好的恢复内容的完整数据返回
        resumeArticle() {
            var that = this;
            this.$refs.voiceEditBtn.resumeArticle({
                clipDate: that.clipDate
            })
        },
        editaudiohd(r) {
            var that = this;
            if(r.type=="editaudiohd"){
                console.log(r.content)
                this.audioLoading = false;
                this.isAudioSubmit = true;
                this.composeContent = r.content
                this.audioPlayer.src = r.content.url;
                this.audioPlayer.load();
                this.audioPlayer.oncanplay = function() {
                    that.duration = parseInt(that.audioPlayer.duration);
                    that.endTime = that.s2hms(parseInt(that.audioPlayer.duration));
                    that.startTime = that.s2hms(parseInt(that.audioPlayer.currentTime));
                    var percent = ((parseInt(that.audioPlayer.currentTime)/parseInt(that.audioPlayer.duration))*100).toFixed(2) + '%';
                    that.audioPercent = percent;
                    // that.interval = setInterval(function(){
                    //     that.startTime = that.s2hms(parseInt(that.audioPlayer.currentTime));
                    //     var percent = ((parseInt(that.audioPlayer.currentTime)/parseInt(that.audioPlayer.duration))*100).toFixed(2) + '%';
                    //     that.audioPercent = percent;
                    //     console.log(998)
                    // },500)
                }

                this.audioPlayer.ontimeupdate = function(e) {
                    that.startTime = that.s2hms(parseInt(e.target.currentTime));
                    let percent = ((parseInt(e.target.currentTime)/parseInt(e.target.duration))*100).toFixed(2) + '%';
                    that.audioPercent = percent;
                }

                this.audioPlayer.onended  = function() {
                    // console.log(999)
                    that.isPlayAudio = false;
                    // clearInterval(this.newTime)
                }
            }
        },
        loadwavesurferjs() {
            return common.load(config.wavesurferjs)
        },
        loadutiljs() {
            return common.load(config.utiljs)
        },
        loadwebaudiojs() {
            return common.load(config.webaudiojs)
        },
        loadmediaelementjs() {
            return common.load(config.mediaelementjs)
        },
        loaddrawerjs() {
            return common.load(config.drawerjs)
        },
        loaddrawerCanvasjs() {
            return common.load(config.drawerCanvasjs)
        },
        loadaudiosequencejs() {
            return common.load(config.audiosequencejs)
        },
        loadwavesurferEditorjs() {
            return common.load(config.wavesurferEditorjs)
        },
        loadwavesurferRegionsjs() {
            return common.load(config.wavesurferRegionsjs)
        },
        loadwavesurferTimelinejs() {
            return common.load(config.wavesurferTimelinejs)
        },
        loadwavesurferMinimapjs() {
            return common.load(config.wavesurferMinimapjs)
        },
        load() {
            return this.loadwavesurferjs().then(() => {
                return this.loadutiljs().then(() => {
                    return Promise.all([this.loadwebaudiojs(), this.loadmediaelementjs(), this.loaddrawerjs(), this.loaddrawerCanvasjs(), this.loadaudiosequencejs(), this.loadwavesurferEditorjs(), this.loadwavesurferRegionsjs(), this.loadwavesurferTimelinejs(), this.loadwavesurferMinimapjs()])
                })
            })
        },
        getp() {
            var that = this;
            this.showCompose = true;
            this.audioLoading = false;
            this.isAudioSubmit = true;
            this.audioPlayer.src = 'https://media.smgtech.net:8443/radiodev/original/2020/05/15/392win3b3935b18e451fa6dbf73d746111190915.mp3.wav';
            this.audioPlayer.load();
            this.audioPlayer.oncanplay = function() {
                that.duration = parseInt(that.audioPlayer.duration);
                that.endTime = that.s2hms(parseInt(that.audioPlayer.duration));
                that.startTime = that.s2hms(parseInt(that.audioPlayer.currentTime));
                var percent = ((parseInt(that.audioPlayer.currentTime)/parseInt(that.audioPlayer.duration))*100).toFixed(2) + '%';
                that.audioPercent = percent;
                // that.interval = setInterval(function(){
                //     that.startTime = that.s2hms(parseInt(that.audioPlayer.currentTime));
                //     var percent = ((parseInt(that.audioPlayer.currentTime)/parseInt(that.audioPlayer.duration))*100).toFixed(2) + '%';
                //     that.audioPercent = percent;
                // },500)
            }

            this.audioPlayer.ontimeupdate = function(e) {
                that.startTime = that.s2hms(parseInt(e.target.currentTime));
                let percent = ((parseInt(e.target.currentTime)/parseInt(e.target.duration))*100).toFixed(2) + '%';
                that.audioPercent = percent;
            }

            this.audioPlayer.onended  = function() {
                // console.log(999)
                that.isPlayAudio = false;
                // clearInterval(this.newTime)
            }
        }
    },
    destroyed: function() {

    },
    mounted() {
        var that = this;
        
        window.onbeforeunload = function(e) {
          const event = e || window.event
          return event.returnValue = true
        }

        this.audioPlayer = this.$refs.audioPlayer;

        // this.getp();

        mainCommon.handleSocket(this.editaudiohd, 'editaudiohd')

        document.onkeydown=function(event){
            var e = event || window.event || arguments.callee.caller.arguments[0];
            var ctrlKey = e.ctrlKey || e.metaKey;
            if(e.keyCode==32){
                // 音频暂停事件
                // that.playPauseAudio = Math.random();
                that.$refs.voiceEditBtn.playPauseAudioEvent()
            }else if(e.keyCode==8){
                // Backspace删除事件
                that.delArticle();
            }else if(ctrlKey&&e.keyCode==67){
                // 文字复制事件
            }else if(ctrlKey&&e.keyCode==86){
                // 文字粘贴事件
            }else if(ctrlKey&&e.keyCode==90){
                // ctrl + Z 恢复删除时间段
                that.resumeArticle();
            }
        };

        (function (doc, win) {

            var docEl = doc.documentElement,

                resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',

                recalc = function () {
                    var clientWidth = docEl.clientWidth;

                    if (!clientWidth) {

                        return;
                    }
                    var s = 100 * (clientWidth / 1920);
                    var inputWidth = s * 5.9 + 'px'
                    that.inputWidth = inputWidth;
                    var height = 570 - (969-docEl.clientHeight) + 'px';
                    that.inputHeight = height;
                    if(that.inputHeight!='0px'){
                        that.hideContent = false;
                    }
                    // $('.edui-editor-iframeholder.edui-default').css('height',height);
                    // let edui = document.querySelector('.edui-editor-iframeholder.edui-default');
                    // console.log(edui)
                    // edui.style.height = height
                };

                setTimeout(() => {
                    recalc();
                }, 1000);


            if (!doc.addEventListener) {

                return;
            }
            win.addEventListener(resizeEvt, recalc, false);

            doc.addEventListener('DOMContentLoaded', recalc, false);

        })(document, window);
    },
    created() {
        var that = this;
        // var id = this.$route.params.id;
        // that.getDetail(id);
        // that.uid = id;
        let domin = window.document.domain;
        let isXnew = true;
        if(domin.indexOf('xnews')!=-1){
            isXnew = true
        }else if(domin.indexOf('localhost')!=-1){
            isXnew = true
        }else{
            isXnew = false
        }
        this.isXnew = isXnew;
        this.load().then(() => {
            that.isLoad= true
            that.getDetail();
        })
    }
}
</script>

<style scoped>
    .mask-container {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 999;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.8)
    }

    .mask-container .mask {
        position: absolute;
        top: 50%;
        left: 50%;
        margin-left: -147px;
        margin-top: -100px;
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 294px;
        height: 200px;
        border-radius: 4px;
        background: #FFF;
        user-select: none;
    }

    .mask-container .mask p {
        font-size: 20px;
        color: #050F0F;
        margin: 32px 0;
    }

    .mask-container .mask img {
        width: 42px;
        height: 44px;
        animation: rotate 2s linear infinite;
    }

    .mask-container .voiceEditResult-container {
        position: absolute;
        top: 50%;
        left: 50%;
        margin-top: -244px;
        margin-left: -428px;
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 856px;
        height: 488px;
        border-radius: 4px;
        background: #EBF0F5;
        overflow: hidden;
    }

    .mask-container .voiceEditResult-container .title {
        font-size: 24px;
        line-height: 32px;
        color: #050F0F;
        margin-top: 20px;
        margin-bottom: 20px;
    }

    .mask-container .voiceEditResult-container .content {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: 307px;
        padding: 0 38px;
        box-sizing: border-box;
    }

    .mask-container .voiceEditResult-container .content .left-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 348px;
        height: 100%;
        border-radius: 4px;
        background: #F9F9F9;
        box-shadow: 0 2px 4px rgba(100,100,100,0.5);
    }

    .mask-container .voiceEditResult-container .content .left-container .disk-container {
        position: relative;
        width: 175px;
        height: 175px;
        margin-top: 34px;
        margin-bottom: 55px;
    }

    .mask-container .voiceEditResult-container .content .left-container .disk-container .disk {
        width: 175px;
        height: 175px;
    }

    .mask-container .voiceEditResult-container .content .left-container .disk-container .play {
        position: absolute;
        top: 50%;
        left: 50%;
        margin-top: -11px;
        margin-left: -11px;
        width: 22px;
        height: 22px;
        user-select: none;
        cursor: pointer;
    }

    .mask-container .voiceEditResult-container .content .left-container .disk-container .pause {
        position: absolute;
        top: 50%;
        left: 50%;
        margin-top: -13px;
        margin-left: -13px;
        width: 26px;
        height: 26px;
        user-select: none;
        cursor: pointer;
    }

    .mask-container .voiceEditResult-container .content .left-container .slide-container{
        position: relative;
    }

    .mask-container .voiceEditResult-container .content .left-container .time-container {
        position: absolute;
        top: -28px;
        right: 0;
        display: flex;
        flex-direction: row;
        align-items: center;
        font-size: 13px;
        font-weight: bold;
        color: #B9C3C3;
    }

    .mask-container .voiceEditResult-container .content .left-container .time-container:nth-of-type(1) {
        color: #829191;
    }

    .mask-container .voiceEditResult-container .content .left-container .line-container {
        position: relative;
        width: 310px;
        height: 3px;
        border-radius: 1.5px;
        background: rgb(235,235,235);
        /* box-shadow: 0 2px 4px rgba(100,100,100,0.5); */
        user-select: none;
    }

    .mask-container .voiceEditResult-container .content .left-container .line-container .line {
        position: absolute;
        top: 0;
        left: 0;
        width: 0%;
        height: 3px;
        background: #41B48C;
    }

    .mask-container .voiceEditResult-container .content .left-container .line-container .line .slider {
        position: absolute;
        right: -8px;
        top: -8px;
        width: 16px;
        height: 16px;
        border-radius: 50%;
        background: #FFF;
        box-shadow: 6px 6px 20px rgba(0,0,0,0.05);
        cursor: pointer;
    }

    .mask-container .voiceEditResult-container .content .right-container {
        display: flex;
        flex-direction: column;
        width: 408px;
        height: 100%;
        border-radius: 4px;
        background: #F9F9F9;
        padding: 0 26px 0 23px;
        box-shadow: 0 2px 4px rgba(100,100,100,0.5);
        box-sizing: border-box;
    }

    .mask-container .voiceEditResult-container .content .right-container .title {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin: 15px 0 18px 0;
    }

    .mask-container .voiceEditResult-container .content .right-container .title span {
        font-size: 16px;
        line-height: 16px;
        color: #FF555A;
    }

    .mask-container .voiceEditResult-container .content .right-container .title p {
        font-size: 16px;
        color: #050F0F;
        margin-left: 3px;
    }

    .mask-container .voiceEditResult-container .content .right-container .input {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 359px;
        height: 40px;
        background: rgba(185,195,195,0.2);
        border-radius: 4px;
        margin-bottom: 20px;
        padding: 0 20px;
        box-sizing: border-box;
    }

    .mask-container .voiceEditResult-container .content .right-container .input input {
        width: 100%;
        height: 100%;
        border: none;
        outline: none;
        background: transparent;
        font-size: 14px;
        color: #494949;
    }

    .mask-container .voiceEditResult-container .content .right-container .notice {
        display: flex;
        flex-direction: row;
        align-items: center;
        height: 14px;
    }

    .mask-container .voiceEditResult-container .content .right-container .notice span {
        font-size: 14px;
        color: #41B48C;
        margin-left: 10px;
    }

    .mask-container .voiceEditResult-container .footer {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 80px;
        background: #F9F9F9;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        box-shadow: 0 0 10px 0 rgba(6,21,50,0.05);
    }

    .mask-container .voiceEditResult-container .footer .button {
        width: 120px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        font-size: 14px;
        background: #B9C3C3;
        color: #FFF;
        border-radius: 30px;
        cursor: pointer;
        user-select: none;
    }

    .mask-container .voiceEditResult-container .footer .button.green {
        background: #41B48C;
        margin-right: 50px;
    }

    .mask-container .success-container {
        position: absolute;
        top: 50%;
        left: 50%;
        margin-top: -145px;
        margin-left: -200px;
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 400px;
        height: 290px;
        border-radius: 4px;
        background: #F9F9F9;
    }

    .mask-container .success-container img {
        width: 50px;
        height: 50px;
        margin-top: 40px;
    }

    .mask-container .success-container p {
        font-size: 20px;
        line-height: 26px;
        color: #050F0F;
        margin: 30px 0 14px;
    }

    .mask-container .success-container span {
        font-size: 14px;
        line-height: 18px;
        color: #829191;
    }

    .mask-container .success-container .button {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-top: 32px;
        cursor: pointer;
        user-select: none;
    }

    .mask-container .success-container .button div {
        width: 120px;
        height: 40px;
        background: #41B48C;
        line-height: 40px;
        text-align: center;
        border-radius: 30px;
        font-size: 14px;
        color: #FFFFFF;
    }

    .mask-container .fail-container {
        position: absolute;
        top: 50%;
        left: 50%;
        margin-top: -145px;
        margin-left: -200px;
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 400px;
        height: 290px;
        border-radius: 4px;
        background: #F9F9F9;
    }

    .mask-container .fail-container img {
        width: 50px;
        height: 50px;
        margin-top: 40px;
    }

    .mask-container .fail-container p {
        font-size: 20px;
        line-height: 26px;
        color: #050F0F;
        margin: 30px 0 14px;
    }

    .mask-container .fail-container span {
        font-size: 14px;
        line-height: 18px;
        color: #829191;
    }

    .mask-container .fail-container .button {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-top: 32px;
        cursor: pointer;
        user-select: none;
    }

    .mask-container .fail-container .button div {
        width: 120px;
        height: 40px;
        background: #41B48C;
        line-height: 40px;
        text-align: center;
        border-radius: 30px;
        font-size: 14px;
        color: #FFFFFF;
    }

    .mask-container .leave-container {
        position: absolute;
        top: 50%;
        left: 50%;
        margin-top: -145px;
        margin-left: -200px;
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 400px;
        height: 290px;
        border-radius: 4px;
        background: #F9F9F9;
    }

    .mask-container .leave-container img {
        width: 50px;
        height: 50px;
        margin-top: 40px;
    }

    .mask-container .leave-container p {
        font-size: 20px;
        line-height: 26px;
        color: #050F0F;
        margin: 30px 0 14px;
    }

    .mask-container .leave-container span {
        font-size: 14px;
        line-height: 18px;
        color: #829191;
    }

    .mask-container .leave-container .button {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-top: 32px;
        cursor: pointer;
        user-select: none;
    }

    .mask-container .leave-container .button div {
        width: 120px;
        height: 40px;
        background: #41B48C;
        line-height: 40px;
        text-align: center;
        border-radius: 30px;
        font-size: 14px;
        color: #FFFFFF;
        margin-right: 20px;
    }

    .mask-container .leave-container .button div.grey {
        width: 120px;
        height: 40px;
        background: #B9C3C3;
        line-height: 40px;
        text-align: center;
        border-radius: 30px;
        font-size: 14px;
        color: #FFFFFF;
        margin-right: 0;
    }

    @keyframes rotate {
        0% {
            transform: rotate(0deg)
        }
        100% {
            transform: rotate(360deg)
        }
    }

    .el-main {
        padding: 50px !important;
        box-sizing: border-box;
    }

    .content-container {
        padding: 30px 50px;
        width: 100%;
        height: 100% !important;
        background: #FFF;
        box-sizing: border-box;
    }

    .content-container .title {
        font-size: 20px;
        color: #333;
        margin-bottom: 35px;
    }

    .content-container .voiceEdit-container {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }

    .content-container .voiceEdit-container > div {
        display: flex;
        flex-direction: row;
        align-items: center;
        cursor: pointer;
    }

    .content-container .voiceEdit-container > div img {
        width: 14px;
        height: 14px;
        margin-right: 10px;
    }

    .content-container .voiceEdit-container > div span {
        font-size: 16px;
        color: #999;
    }

    .content-container .container {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 100%
    }

    .content-container .container .info > p {
        width: 100%;
        height: 1px;
        background: #DDDDDD;
    }

    .content-container .container .info > div {
        font-size: 14px;
        color: #32323C;
    }

    .content-container .container .info > div span {
        color: #919BA4;
    }

    .content-container .container .info .one {
        margin-bottom: 20px;
        margin-top: 30px;
    }

    .content-container .container .info .two {
        display: flex;
        flex-direction: row;
        margin-bottom: 20px;
    }

    .content-container .container .info .two p {
        width: 50%;
    }

    .content-container .container .info .two:nth-last-of-type(1) {
        margin-bottom: 36px;
    }

    .content-container .container .playContainer-container {
        width: 44%;
    }

    .content-container .container .keyword {
        margin-top: 36px;
    }

    .content-container .container .keyword > p {
        font-size: 14px;
        color: #919BA4;
        margin-bottom: 16px;
    }

    .content-container .container .keyword ul {
        overflow: hidden;
    }

    .content-container .container .keyword ul li {
        float: left;
        width: min-content;
        border-radius: 4px;
        font-size: 14px;
        color: #999;
        padding: 1px 8px;
        border: 1px solid #DDD;
        margin: 0 10px 10px 0;
        box-sizing: border-box;
    }

    .content-container .container .playContainer {
        width: 100%;
    }

    .content-container .container .playContainer .el-button {
        width: 70px;
    }

    .content-container .container .playContainer .el-button > span {
        display: flex;
        flex-direction: row;
    }

    .content-container .container .playContainer .el-button > span i.play-btn {
        display: inline-block;
        width: 14px;
        height: 14px;
        background: url('./assets/play.png') no-repeat;
        background-size: 100%;
        background-position: center;
        margin-right: 2px;
        vertical-align: middle;
    }

    .content-container .container .playContainer .el-button > span i.pause-btn {
        display: inline-block;
        width: 14px;
        height: 14px;
        background: url('./assets/pause.png') no-repeat;
        background-size: 100%;
        background-position: center;
        margin-right: 2px;
        vertical-align: middle;
    }

    .content-container .container .playContainer .el-button > span span {
        vertical-align: middle;
    }

    /* .content-container .container .playContainer #audioPlayer {
        width: 100%;
    }

    .content-container .container .playContainer #audioTimeLine {
        width: 100%;
    } */

    textarea {
        width: 100%;
        height: 400px;
    }

    .voiceData-container {
        width: 100%;
        height: 40px;
        margin-bottom: 20px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }

    .voiceData-container .voiceData-btn {
        /* float: right; */
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-end;
        overflow: hidden;
        /* text-align: right; */
        /* margin-bottom: 16px; */
    }

    .voiceData-container .voiceData-btn > span {
        float: left;
        font-size: 16px;
        color: #32323C;
    }

    .voiceData-container .voiceData-btn .el-input {
        float: left;
        width: 590px;
    }

    .voiceData-container .voiceData-btn .el-button {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        padding: 0px;
        width: 100px;
        height: 30px;
        line-height: 30px;
        font-size: 14px;
        color: #FFF;
        border-radius: 4px;
        border: 1px solid #56BCDE;
        background: #56BCDE;
        box-sizing: border-box;
    }

    .voiceData-container .voiceData-btn .el-button.input {
        float: left;
    }

    .voiceData-container .voiceData-btn .el-button.output {
        float: right;
        /* width: 140px; */
        margin-left: 20px;
    }

    .voiceData-container .voiceData-btn .el-button.save {
        float: right;
    }

    .voiceData-container .voiceData-btn .el-button.save .save {
        display: inline-block;
        width: 16px;
        height: 16px;
        background: url('./assets/saveIcon.png') no-repeat;
        background-position: center;
        background-size: 100%;
        vertical-align: middle;
        margin-right: 18px;
    }

    .voiceData-container .voiceData-btn .el-button.compose {
        background: #39CFB1;
        border: 1px solid #39CFB1;
        margin-left: 20px;
        box-sizing: border-box;
    }

    .voiceData-container .voiceData-btn .el-button.compose.on {
        background: #CCC;
        border: 1px solid #CCC;
    }

    .voiceData-container .voiceData-btn .el-button.compose .compose {
        display: inline-block;
        width: 16px;
        height: 16px;
        background: url('./assets/composeIcon.png') no-repeat;
        background-position: center;
        background-size: 100%;
        vertical-align: middle;
        margin-right: 18px;
    }

    .voiceData-container .voiceData-btn .el-button.output .out {
        display: inline-block;
        width: 16px;
        height: 16px;
        background: url('./assets/outIcon.png') no-repeat;
        background-position: center;
        background-size: 100%;
        vertical-align: middle;
        margin-right: 18px;
    }

    .voiceData-container .voiceData-btn .el-button.output.on {
        background: #CCC;
        border: 1px solid #CCC;
    }

    .voiceData-container .voiceData-btn .el-button.output span {
        vertical-align: middle;
    }

    .voiceData {
        width: 100%;
        height: 420px;
        border: 1px solid #DDD;
        padding: 22px 35px;
        box-sizing: border-box;
        overflow-y: scroll;
    }

    .voiceTxt {
        width: 100%;
        height: 420px;
        border: 1px solid #DDD;
        padding: 22px 35px;
        box-sizing: border-box;
        resize: none;
        outline: none;
    }

    .voiceData span {
        /* display: inline-block; */
        padding: 5px 8px;
        background: #EEEEEE;
        border-radius: 4px;
        font-size: 14px;
        line-height: 40px;
        color: #333;
        margin-right: 10px;
        margin-bottom: 10px;
    }

    .voiceData span.on {
        color: #FFF;
        background: #56BCDE;
    }

    .check-btn-container {
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    h3 {
        color: #5F5F5F;
        font-size: 15px;
    }

    /* .mask-container {
        position: fixed;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.4);
        z-index: 99;
    }

    .mask-container .el-progress {
        position: absolute;
        top: 50%;
        left: 50%;
        margin-top: -63px;
        margin-left: -63px;
        color: #FFF;
    } */

    #i_select_files1 {
        height: 180px;
        line-height: 180px;
        text-align: center;
        border: 1px dashed #DDD;
        box-sizing: border-box;
        font-size: 14px;
        color: #32323C;
    }

    .video-container {
        width: 100%;
        height: 200px;
    }

    #video1 {
        width: 100%;
        height: 200px;
    }

    .audioRec-wait {
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .audioRec-wait P {
        font-size: 14px;
    }

    em {
        background: #FFF;
    }

    textarea {
        font-size: 14px;
        color: #333;
        line-height: 40px;
    }

    #edui1_iframeholder {
        font-size: 14px;
    }

    #editorContainer {
        position: absolute;
        top: -100000px;
    }

    #editorContainer1 {
        position: absolute;
        top: -100000px;
    }

    br {
        line-height: 30px !important;
    }

    #hideInput {
        position: absolute;
        top: -1000000px;
    }

    .searchInput-container {
        float: left;
        display: flex;
        flex-direction: row;
        align-items: center;
        /* margin-bottom: 30px; */
        font-size: 16px;
        color: #333;
    }

    .searchInput-container > span {
        user-select: none;
    }

    /* .searchInput-container .el-input {
        width: 370px;
        margin: 0 30px 0 40px;
    } */

    .searchInput-container input {
        width: 360px;
        height: 40px;
        border: 1px solid #dcdfe6;
        outline: none;
        margin-left: 30px;
        padding: 0 15px;
        box-sizing: border-box;
    }

    .searchInput-container .el-button {
        padding: 0px;
        width: 100px;
        height: 30px;
        line-height: 30px;
        font-size: 14px;
        color: #FFF;
        border-radius: 4px;
        border: 1px solid #56BCDE;
        background: #56BCDE;
        box-sizing: border-box;;
    }

    #e2 {
        position: absolute;
        top: -1000000px;
    }

    #e3 {
        position: absolute;
        top: -1000000px;
    }

    #e4 {
        position: absolute;
        top: -1000000px;
    }

    #e5 {
        position: absolute;
        top: -1000000px;
    }

    #e6 {
        position: absolute;
        top: -1000000px;
    }

    #e7 {
        position: absolute;
        top: -1000000px;
    }

    #article-container {
        height: 460px;
        overflow-y: scroll;
        font-size: 14px;
        color: #000;
        line-height: 24px;
        border: 1px solid #DDD;
        padding: 30px;
        box-sizing: border-box;
    }

    /* .mask-container {
        position: absolute;
        top: 50%;
        left: 50%;
        margin-left: -120px;
        margin-top: -67.5px;
        width: 240px;
        height: 135px;
        background: rgba(0,0,0,0.7);
        border-radius: 4px;
    }

    .mask-container img {
        position: absolute;
        top: 50%;
        left: 50%;
        margin-left: -23.5px;
        margin-top: -23.5px;
        width: 47px;
        height: 47px;
        animation: "rotate" 1s infinite;
    } */

    .backIndex {
        display: flex;
        flex-direction: row;
        align-items: center;
        cursor: pointer;
    }

    .backIndex img {
        width: 16px;
        height: 16px;
        margin-left: 40px;
        margin-right: 10px;
        user-select: none;
    }

    .backIndex span {
        font-size: 14px;
        line-height: 20px;
        color: #666;
        user-select: none;
    }

</style>

<style>
    .el-main {
        height: 100%;
        /* padding: 50px 50px 0 50px !important; */
        box-sizing: border-box;
    }

    #article-container > span.on {
        color: #56BCDE;
    }

    #article-container > span > span.on {
        /* background: #999; */
        text-decoration: line-through;
        color: #999;
    }

    #article-container .copyOn {
        color: orange!important;
    }

    #e6 > span > span.on {
        display: none;
    }

    .cutBtn > span {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
    }

    .searchInput-container .el-input .el-input__inner {
        border-radius: 0px !important;
    }

    minimap wave {
       z-index: 9999;
    }

    .el-button {
        padding: 0;
        border: none;
    }
</style>
